import React from 'react'
import Header from '../Menpages/Header/Main'
import Footer from '../Menpages/Footer/Main'
import Bredcom from '../MenTeam/Bredcom'
import Plan from '../Menpricing/Plan'
import Slider from '../Menpages/Testimonials/Main'
import Start from '../Menpricing/Start'
import Sliderfooter from '../Menpages/GlobleSlider/Main'

function Main() {
  return (
    <>
        <div className="page-wrapper">
            <Header/>
            <Bredcom title={"Home"} head={"Pricing Plan"} sbtitle={"Pricing Plan"}/>
            <Plan/>
            <Slider/>
            <Start/>
            <Sliderfooter/>
            <Footer/>
        </div>
    </>
  )
}

export default Main